import { render, staticRenderFns } from "./AssetMessage.vue?vue&type=template&id=1c0bdd0e&scoped=true"
import script from "./AssetMessage.vue?vue&type=script&lang=js"
export * from "./AssetMessage.vue?vue&type=script&lang=js"
import style0 from "./AssetMessage.vue?vue&type=style&index=0&id=1c0bdd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bdd0e",
  null
  
)

export default component.exports